import { useState, useCallback } from 'react';

export default function useEditing() {
  const [isEditing, setEditing] = useState(false);
  const [itemBeingEdited, setItemBeingEdited] = useState();
  const [lastItemEdited, setLastItemEdited] = useState();

  const startEdit = useCallback((item) => {
    setEditing(true);
    setItemBeingEdited(item);
  });
  const finishEdit = () => {
    setLastItemEdited(itemBeingEdited);
    setItemBeingEdited(undefined);
    setEditing(false);
  };

  return {
    commands: {
      startEdit,
      finishEdit,
    },
    sharedStates: {
      isEditing,
      itemBeingEdited,
      lastItemEdited,
    },
  };
}
